export enum DataSourceType {
    PHOTOSPHERE = "PHOTOSPHERE",
    TILED_POINTCLOUD = "TILED_POINTCLOUD",
    POINTCLOUD = "POINTCLOUD",
}
